module.exports = __webpack_public_path__ + "img/FINAL.78adc903.png";